import { debounceTime, noop, Observable, Subscription, tap } from 'rxjs';
import { ChangeDetectorRef, Component, OnInit, OnDestroy, Inject, PLATFORM_ID } from '@angular/core';
import { MainCategory, MainCategory1 } from 'projects/shared/models/category';
import { MainCategoryStoreProvider } from 'projects/shared/providers/category/main-category.provider';
// import { selectAllMainCategoriesEntities, } from 'projects/shared/reducers/category/main-category.reducer';
// import * as fromFeature from 'projects/shared/reducers/category/main-category.reducer';
import { CategoryService } from 'projects/shared/services/category.service';
import { StoreChangesService } from 'projects/shared/services/store-changes.service';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { BrowserService } from 'projects/shared/services/browser.service';
import { NotificationSocketService } from 'projects/shop/src/app/+shared/services/notificationSocket.service';
import { TransferState, makeStateKey } from '@angular/core';
import { LanguageService } from 'projects/shop/src/app/+shared/services/language.service';
const MAIN_CATEGORIES_KEY = makeStateKey<any>('main-categories-nav-links');

@Component({
  selector: 'app-navbar-links',
  templateUrl: './navbar-links.component.html',
  styleUrls: ['./navbar-links.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule]
})

export class NavbarLinksComponent implements OnInit, OnDestroy {

  mainCategoryList?: MainCategory1[];
  subscription: Subscription = new Subscription()
  mainCategories$: Observable<MainCategory[]> | any;
  lang = ''
  arabic = false;

  constructor(
    private mainCategoryStore: MainCategoryStoreProvider,
    private cdr: ChangeDetectorRef, private categoryService: CategoryService,
    private storeChangesServ: StoreChangesService,
    private _browserService: BrowserService,
    private router: Router,
    private notificationSocketService: NotificationSocketService,
    private transferState: TransferState,
        private _languageService: LanguageService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    const locationBr = this._browserService.getLocation();
    if (locationBr) {
      this.lang = location.pathname.split('/')[1]
    }
  }

  ngOnInit(): void {
    this.getAllMainCategories()
    this.language()
  }
  language() {
    this._languageService.arabic.subscribe(
      res => {
        this.arabic = res;
      }
    )

  }


  navigateToCategory(item: any) {
    this.mainCategoriesLocal(item.name); // your existing logic
    // this.router.navigate([`/${this.lang}/categories/${item.slug}`],);
  }

  isActive(slug: any): boolean {
    const url = this.router.url;
    return url === `/${this.lang}/categories/${slug}`;
  }

  mainCategoriesLocal(mainCategoryName: {}) {
    sessionStorage.setItem('mainCategoryNameFromNavbar',  JSON.stringify(mainCategoryName))
  }

  // getAllMainCategories() {
  //   const query = "?sort=order";
  //   this.categoryService.getUserMainCategories(query).subscribe((response) => {
  //     this.mainCategoryList = response.data;
  //     this.initNotificationSocket();
  //   });
  // }
  getAllMainCategories() {
    const query = "?sort=order";
    this.categoryService.getUserMainCategories(query).subscribe((response) => {
      this.mainCategoryList = response.data;
      this.initNotificationSocket();
    });
  }

  initNotificationSocket() {
    this.storeChangesServ.getUser().pipe(
      debounceTime(10000),
      tap(
        user => {
          if (user) this.notificationSocketService.initSocket(user._id);
        }
      )
    ).subscribe(noop)
  }


  ngOnDestroy(): void {
    this.subscription.unsubscribe()
  }

}
